import React from 'react'
import {connect} from 'react-redux'
import CustomizationModel from '/app/src/model/Customization/model';
import {LoadingScreen} from '/app/src/component';

const withCustomization = (WrapperComponent) => {
        class WithCustomization extends React.Component {
            componentDidMount(){
                this.props.readCustomizations()
            }
            render(){
                const network = this.props.network
                if(network.fetching && !network.fetched){
                    return <LoadingScreen/>
                }
                return <WrapperComponent {...this.props}/>
            }
        }

        const {selector: customizationReadSelector, dispatcher: customizationDispatcher} = CustomizationModel.read()

        function mapDispatchToProps(dispatch, props) {
            return { readCustomizations: () => dispatch(customizationDispatcher()) }
        }

        function mapStateToProps(state, props) {
            const network = customizationReadSelector(state)['network'].toJS();
            return { network }
        }
        return connect(mapStateToProps, mapDispatchToProps)(WithCustomization)
}

export default withCustomization



// WEBPACK FOOTER //
// ./src/hoc/withCustomization.js